import styled, {css} from 'styled-components'

const Style = {
	Wrapper: styled.div`
		display: flex;
		flex-direction: column;
		gap: 24px;
	`,
	Area: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;

		${({$expand}) =>
			$expand &&
			css`
				flex: 1;
			`}

		& > h2 {
			width: 100%;
			${({theme}) => theme.font.extra_small_bold};
		}
	`,
}
export default Style
